// extracted by mini-css-extract-plugin
export default {"container":"text_container__3XE-_","title":"text_title__2rIrG","padded":"text_padded__YsDbu","inner":"text_inner__17F7p"};